import { getRgObjectsOfType as i, RG_TYPE as o } from "@project-rouge/rg-core";
import { SumArray as m } from "../../../utils/array/index5.js";
const p = (r, a) => {
  let e = 0;
  const l = i(r, o.Building);
  for (const s of l) {
    const n = i(s, o.Apartment).filter((t) => t.data.level === a);
    if (!n.length)
      continue;
    const f = n.map((t) => t.data.nia || 0);
    e += m(f);
  }
  return e;
};
export {
  p as getLevelNIA
};
//# sourceMappingURL=index25.js.map
